import { render } from "./profCard.vue?vue&type=template&id=f43024b2&scoped=true&bindings={\"prof\":\"props\",\"blue\":\"props\",\"up\":\"props\",\"index\":\"props\",\"profProp\":\"setup\",\"blueProp\":\"setup\",\"upProp\":\"setup\",\"myIndex\":\"setup\",\"imgProp\":\"setup\"}"
import script from "./profCard.vue?vue&type=script&lang=js"
export * from "./profCard.vue?vue&type=script&lang=js"

import "./profCard.vue?vue&type=style&index=0&id=f43024b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f43024b2"

export default script